// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { LogOut } from "lucide-react";
import { useTranslation } from "react-i18next";
import { FocalLogoIcon } from "@/components/icons";
import { LanguageSwitcher } from "@/components/layout/language-switcher";
import { ThemeToggle } from "@/components/layout/theme-toggle";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth/auth-provider";

export function NoAccess() {
  const { t } = useTranslation("back-office");
  const { user, logout } = useAuth();

  return (
    <div className="relative flex min-h-svh items-center justify-center p-8">
      <div className="absolute bottom-4 right-4 lg:bottom-10 lg:right-10 flex items-center gap-1">
        <LanguageSwitcher />
        <ThemeToggle />
      </div>
      <div className="mx-auto flex flex-col items-center gap-6 text-center">
        <div className="flex flex-col items-center gap-2">
          <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary">
            <FocalLogoIcon width={24} height={24} className="text-white" />
          </div>
          <h1 className="text-2xl font-medium tracking-tight">{t("appTitle")}</h1>
        </div>
        <div className="space-y-2">
          <h2 className="text-lg font-semibold">{t("noAccess.title")}</h2>
          <p className="text-sm text-muted-foreground">{t("noAccess.description")}</p>
          <p className="text-sm text-muted-foreground">{t("noAccess.hint")}</p>
        </div>
        {user?.email && (
          <p className="text-xs text-muted-foreground">{t("noAccess.signedInAs", { email: user.email })}</p>
        )}
        <Button variant="outline" onClick={() => logout()}>
          <LogOut className="h-4 w-4" />
          {t("noAccess.signOut")}
        </Button>
      </div>
    </div>
  );
}
